import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { HttpClientModule } from '@angular/common/http';
import { ServicesModule } from './core/services/services.module';
import { RootStoreModule } from './@root-redux/root-store.module';
import { ShellModule } from './shell/shell.module';
import { NGFSeoModule, SeoSettings } from '@tn-goldenfront/core/seo';
import { environment } from 'src/environments/environment';
import { PlatformService } from '@tn-goldenfront/core/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { EquisLoadingModule } from '@tn-equis/core/components/loading';
import { MdToHtmlPipe } from './shared/pipes/md-to-html.pipe';
import TokenValidator from '@nx/web-token-validator';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    ServicesModule,
    RootStoreModule,
    EquisLoadingModule,
    ShellModule,
    NGFSeoModule.forRoot({
      gtm: {
        gtmId: environment.seo.gtmId,
        logging: environment.seo.logging,
        canonicalDomain: environment.seo.canonicalDomain,
      },
    } as SeoSettings),
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
  ],
  providers: [
    PlatformService,
    {
      provide: TokenValidator,
      useFactory: (): TokenValidator =>
        new TokenValidator({ tokenKey: 'auth0User' }),
    },
    MdToHtmlPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
